import React from 'react'
import { Pagination } from 'antd'
import './newpagination.less'

class NewPagination extends React.Component {
  state = {

  }
  componentDidMount () {

  }
  render () {
    const {total, current, pagesize} = this.props
    return (
      <div className='fl_row_justy'>
        <span>
        共{total}条记录 第{current}/{Math.ceil(total / pagesize)}页
        </span>
        <Pagination showSizeChanger showQuickJumper pageSizeOptions={['10', '20', '30', '40', '50']} pageSize={pagesize || 10}
          total={total} current={current} onChange={this.props.pageChage} onShowSizeChange={this.props.sizeChange} />
      </div>
    )
  }
}
export default NewPagination



// WEBPACK FOOTER //
// ./src/compenents/newpagination/newpagination.js